import classNames from 'classnames'
import React from 'react'
import { ValueLocked } from 'src/components/framework/icons/value-locked'
import { ScoreHeader } from 'src/components/page/ratios/score-header'
import * as styles from 'src/components/page/ratios/scores/f-score/f-score.module.scss'

export const FScore: React.FC = () => {
  const scale = [...Array(10)]
  return (
    <>
      <ScoreHeader
        title={'Health trend'}
        score={'F-Score'}
        id={'piotroski-f-score-ttm-671'}
      />
      <div className={classNames(styles.fScoreGraph__bar, 'stk-space-out-t-2')}>
        <span className={styles.fScoreGraph__icon}>
          <ValueLocked />
        </span>
      </div>
      <div className={classNames(styles.fScoreGraph__scale, 'stk-text-small')}>
        {scale.map((a, index) => (
          <span key={index}>{index + 1}</span>
        ))}
      </div>
    </>
  )
}
